export default __webpack_public_path__ + "static/media/full3.dae0df5e.jpg";